
import { Watch, Mixins, Component, InjectReactive } from "vue-property-decorator";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";

import AddDialog from "./add.vue"; 

import { getConsultationList, getTenConsultationList, updateFdmStatus } from "@/api/consultation";
import { GenderEnum3 } from "@/enum/symptoms.enum";
import { StatusEnum } from "@/enum/common.enum";

import { cloneDeep } from "lodash";

export interface IBookingListQueryForm {
    times: Array<any>,
    status: undefined | number | string,
    storeName: string,
    userPhone: string | number,
    [key: string]: any,
}

@Component({
    components: {
        ETable, AddDialog
    }
})
export default class ConsultationList extends Mixins(TablePagination, Resize) {
    @InjectReactive() currentTab!: string|number;
    @InjectReactive() merchantId!: string|number;

    queryForm = {
        name: "",
        diagResult: "",
        relationViscera: "",
        suitable: "",
        symptomStatus: ""
    }

    columns = [
        { label: "名称", prop: "name" },
        { label: "诊断结果", prop: "diagResult" },
        { label: "对应脏腑", prop: "", formatter: (row) => row.relationVisceraList.join("、") },
        { label: "适用人群", formatter: (row) => GenderEnum3[row.suitable] },
        { label: "四诊调养数量", prop: "fdmConsultationCount" },
        { label: "状态", formatter: (row) => StatusEnum[row.symptomStatus as string] },
        { label: "操作人", prop: "modifiedBy" },
        { label: "最后操作时间", prop: "modifiedTime" },
        { label: "操作", prop: "action" },
    ];

    tableData = [];
    itemTotal = 0;

    loading = false

    addDialogVisible = false;
    editData = {};

    tenConsultationList = [];

    organOptions = [
        "心","肺","肝","胆","肾","膀胱","胃","脾","大肠","小肠","三焦"
    ];
    

    mounted() {
        this.windowResize(350);
        this.getTenConsultationList();
    }

    handleStatusChange(row) {
        updateFdmStatus({ id: row.id, symptomStatus: Number(!row.symptomStatus) }).then(() => {
            this.getData();
        })
    }

    getTenConsultationList() {
        getTenConsultationList().then((res) => {
            console.log("res", res)
            this.tenConsultationList = res.data;
        })
    }


    getConsultationList() {
        const params = {
            ...this.queryForm,
            pageSize: this.pageSize,
            pageNum: this.currentPage,
        }
        this.loading = true;
        getConsultationList(params).then((res) => {
            this.tableData = res.data.list;
            this.itemTotal = res.data.total;
        }).finally(() => {
            this.loading = false;
        })
    }

    @Watch("currentTab", { immediate: true })
    getData() {
        if (this.currentTab != 1) return;
        this.getConsultationList();
    }

    //重置分页参数
    resetPages() {
      this.currentPage = 1;
    }

    handleSearch() {
        this.resetPages();
        this.getData();
    }

    handleEdit(row = { suitable: 0, symptomStatus: 1, relationVisceraList: [] }) {
        this.addDialogVisible = true;
        this.editData = cloneDeep(row);
    }
vLoading(vLoading: any) {
throw new Error("Method not implemented.");
}
}
